export const umapCN = {
    'Umap.Tabs.Name': '数据分析',
    'Umap.Tabs.Cell.Type': '子集',
    'Umap.Tabs.Sample': '样本',
    'Umap.Tabs.Sample.Group': '样本分组',
    'Umap.Select.All': '选择所有',
    'Umap.View': '可视化',
    'Umap.Task': '任务',
    'Umap.Subset': '子集',
    'Umap.color.By': '着色',
    'Umap.Scatter.Size': '点大小',
    'Umap.Opacity': '透明度',
    'Umap.X.Axis': 'x轴',
    'Umap.Y.Axis': 'y轴',
    'Umap.On.Cluster': 'Cluster标签',
    'Umap.Label.On.Side': '标记在旁边',
    'Umap.Label.On.Cluster': '标记在图上',
    'Umap.Change.Color.Tips': '点击色块更改Cluster颜色',
    'Umap.Standard.Publication.Colors': '目前展示颜色',
    'Umap.Choose.More.Colors': '更改颜色',
    'Umap.Change.Color.Default': ' 默认',
    'Umap.Change.Color.Customize': '自定义',
    'Umap.Color.Palettes': '颜色色板',

    'Umap.Click.To.Download.Image': ' 点击下载图片',
    'Umap.Selection.Of.Color.Schema': '选择配色方案',

    'Image.Scale.Zoom': 'Zoom',
    'Violin.Plot.Data.Point': 'Data point',

    'Group.Add.Group': '新增样本分组',
    'Group.New.Metadata.Name': '新分组名称',
    'Group.In.This.Metadata': '组份',
    'Group.Add.Groups.In.Metadata': '添加新组份',
    'Group.No.Sample.Selection': '没有可选样本。',
    'Group.All.Sample.Selected.Tips': '请确保所有样本已选中。',
    'Group.Name.Exists': '名称已存在，请重新输入。',
    'Group.Delete.Message.Box': '该样本分组删除后无法恢复',
    'Umap.Legend.Font.Size': '图例字体大小',
    'Umap.Background.Brightness': '背景图亮度',
    'Umap.Background.Rotation': '旋转',
    'Umap.Horizontal.Flip': '水平翻转',
    'Umap.Color.Change.Tip1': '同一子集中的不同cluster不能使用相同的颜色。',
    'Umap.Color.Change.Tip2': '请输入6位HEX颜色编码(#RRGGBB)。',
    'Spatial.View': '空间视图',
    'Spatial.View.Rotation': '旋转',
    'Spatial.View.Flip': '水平翻转',
    'Spatial.View.Brightness': '亮度',
    'Spatial.View.Contrast': '对比度',
    'Spatial.View.Reset': '重置',
    'Spatial.View.Opacity': '透明度',
    'Spatial.View.Point.Size.Multiplier': '点大小倍率',
    'Spatial.View.Background.Opacity': '背景透明度',

};

export const umapUS = {
    'Umap.Tabs.Name': 'Data and analysis',
    'Umap.Tabs.Cell.Type': 'Subset',
    'Umap.Tabs.Sample': 'Sample',
    'Umap.Tabs.Sample.Group': 'Sample group',
    'Umap.Select.All': 'Select all',
    'Umap.View': 'View',
    'Umap.Task': 'Task',
    'Umap.Subset': 'Subset',
    'Umap.color.By': 'Color by',
    'Umap.Scatter.Size': 'Scatter size',
    'Umap.Opacity': 'Opacity',
    'Umap.X.Axis': 'X-axis',
    'Umap.Y.Axis': 'Y-axis',
    'Umap.On.Cluster': 'Cluster label',
    'Umap.Label.On.Side': 'Label on side',
    'Umap.Label.On.Cluster': 'Label on cluster',
    'Umap.Change.Color.Tips': 'Click on color blocks to change cluster color',
    'Umap.Standard.Publication.Colors': 'Standard Publication colors',
    'Umap.Choose.More.Colors': 'Choose more colors',
    'Umap.Change.Color.Default': 'Default',
    'Umap.Change.Color.Customize': 'customize',
    'Umap.Color.Palettes': 'Color palettes',
    'Umap.Click.To.Download.Image': 'Click to download image',
    'Umap.Selection.Of.Color.Schema': 'Selection of color schemes',

    'Image.Scale.Zoom': 'Zoom',
    'Violin.Plot.Data.Point': 'Data point',

    'Group.Add.Group': 'Add a new sample group ',
    'Group.New.Metadata.Name': 'New metadata name',
    'Group.In.This.Metadata': 'Groups in this metadata',
    'Group.Add.Groups.In.Metadata': 'Add groups in this metadata',
    'Group.No.Sample.Selection': 'No more samples available for selection.',
    'Group.All.Sample.Selected.Tips': 'Please ensure that all samples are selected.',
    'Group.Name.Exists': 'Name exists, please type another.',
    'Group.Delete.Message.Box': 'This sample group will be deleted permanently.',

    'Umap.Legend.Font.Size': 'Legend font size',
    'Umap.Background.Brightness': 'Background brightness',
    'Umap.Background.Rotation': 'Background rotation',
    'Umap.Horizontal.Flip': 'Horizontal flip',
    'Umap.Color.Change.Tip1': 'The different clusters within the same subset cannot use the same color. ',
    'Umap.Color.Change.Tip2': 'Please enter 6 digits HEX color code(#RRGGBB).',
    'Spatial.View': 'Spatial view',
    'Spatial.View.Rotation': 'Rotation',
    'Spatial.View.Flip': 'Horizontal flip',
    'Spatial.View.Brightness': 'Brightness',
    'Spatial.View.Contrast': 'Contrast',
    'Spatial.View.Reset': 'Reset',
    'Spatial.View.Opacity': 'Opacity',
    'Spatial.View.Point.Size.Multiplier': 'Point size multiplier',
    'Spatial.View.Background.Opacity': 'Background opacity',
};